import React from "react";
import { toast } from "react-toastify";
import { putApi } from "../AppApis";

export default function CancelSubscriptionPopup({ onClose, navigate, propertyDetails }) {
    const onPressYes = async () => {
        try {
            let payload = {
                package_type: "basic",
                next_billing_date: "",
                token: "",
                payment_amount: 0,
                card_holder_name: "",
            };
            const url = "/property-services/update_subscription_plan/" + propertyDetails?.property_id;
            const response = await putApi(url, payload);
            if (response?.error) {
                toast.error(response.error);
                return;
            } else {
                toast.success("Subscription cancelled successfully");
                navigate("/MyProperties");
            }
        } catch (error) {
            console.log("🚀 ~ onPressYes ~ error:", error);
        }
    };
    return (
        <div
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 99999 }}
            className="tw-fixed tw-z-50 tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-items-center tw-justify-center tw-flex"
        >
            <div className="tw-bg-white tw-rounded-md tw-px-10 tw-py-10 ">
                <h2 className="tw-text-black tw-text-[20px] ">Are you sure you want to cancel your subscription?</h2>
                <div className="tw-flex tw-justify-center tw-gap-10 tw-mt-5">
                    <button onClick={onClose} className="tw-text-black tw-border tw-border-black tw-px-5 tw-py-2 tw-rounded-md">
                        Cancel
                    </button>
                    <button onClick={onPressYes} className="tw-bg-red-500 tw-text-white tw-px-5 tw-py-2 tw-rounded-md">
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
}
